const typographyModalDocEmployee = {
  true: 'Register New Document',
  false: 'Edit Document'
};

export default typographyModalDocEmployee;
